<gtd-ui-field-default-link *ngIf="data?.source" [displayData]="data?.source" [relationData]="data?.id" [rbacProperty]="">
</gtd-ui-field-default-link>
<gtd-ui-field-default-string-whitespace-or-empty [data]="'UNK'" *ngIf="!data?.source"></gtd-ui-field-default-string-whitespace-or-empty>
